<div class="container">

    <div class="row" style="margin: 0 30px;">
        <div class="col">
            <div class="row align-items-center">
                <div class="col">
                    <nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='currentColor'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="/ad-accounts">Ad Accounts</a></li>
                            <li class="breadcrumb-item"><a routerLink="/ad-accounts/{{ accountId }}">{{ accountId | titlecase }}</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Performance Insights Dashboard</li>
                        </ol>
                    </nav>
                </div>
                <div class="col-auto">
                    <div class="row align-items-center">
                        <div class="col">
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <div class="input-group-text"><a routerLink="/ad-accounts/performance-insights/{{ accountId }}/ads">Ads</a></div>                                                        
                                <div class="input-group-text" style="font-weight: bold;">Creatives</div>                                                        
                                <div class="input-group-text" style="color: #bebebe;">Products</div>                                                        
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>         
            
            <div style="margin-top: 30px;">

                <div style="text-align: center; margin: 20px 0;">
                    <span class="text-primary" (click)="changeView('creativesTopROAS')" style="cursor: pointer;">Top by ROAS</span>
                    <span style="margin-left: 15px; margin-right: 15px;">|</span>
                    <span class="text-primary" (click)="changeView('creativesLowestROAS')" style="cursor: pointer;">Lowest by ROAS</span>
                    <span style="margin-left: 15px; margin-right: 15px;">|</span>
                    <span class="text-primary" (click)="changeView('creativesSource')" style="cursor: pointer;">Creative Source</span>
                    <span style="margin-left: 15px; margin-right: 15px;">|</span>
                    <span class="text-primary" (click)="changeView('creatives')" style="cursor: pointer;">All Creatives</span>
                </div>

                <!-- 
                All Creatives View
                -->
                <div *ngIf="views.creatives.show">
                    <div class="row align-items-center" style="margin-bottom: 10px;">
                        <div class="col">
                            <h3>{{ views.creatives.title }}</h3>
                            <div class="small">{{ views.creatives.description }}</div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.creatives.dateStart"
                                    name="dp"
                                    [(ngModel)]="views.creatives.dateStart"
                                    (ngModelChange)="changeDate('creatives', 'start', $event)"
                                    ngbDatepicker
                                    #datePickerCreativesDateStart="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickerCreativesDateStart.toggle()" type="button"></button>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.creatives.dateEnd"
                                    name="dp"
                                    [(ngModel)]="views.creatives.dateEnd"
                                    (ngModelChange)="changeDate('creatives', 'end', $event)"
                                    ngbDatepicker
                                    #datePickerCreativesDateEnd="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickerCreativesDateEnd.toggle()" type="button"></button>
                            </div>
                        </div>
                    </div>
                    <table style="margin-bottom: 30px;" class="table table-sm table-striped table-bordered tableInsights">
                        <thead>
                            <tr>
                                <th scope="col" style="width: 60px;"></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('creatives', 'id')" style="cursor: pointer;">Creative Id</span></th>
                                <th scope="col">Creative Source</th>
                                <th scope="col">Creator</th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('creatives', 'amount_spent')" style="cursor: pointer;">Spend</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('creatives', 'purchases')" style="cursor: pointer;">Purchases</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('creatives', 'revenue')" style="cursor: pointer;">Revenue</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('creatives', 'roas')" style="cursor: pointer;">ROAS</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="views.creatives.loadingCreatives">
                                <tr>
                                    <td colspan="8" style="text-align: center;"><span class="spinner-border text-dark" role="status" aria-hidden="true" style="vertical-align: middle; margin: 10px 0;"></span></td>
                                </tr>
                            </ng-container>
                            <ng-container *ngFor="let creative of views.creatives.creatives">
                                <tr>
                                    <td><a [href]="creative.image_url" target="_blank"><img [src]="creative.image_url" style="width: 50px; height: 50px;"></a></td>
                                    <td>{{ creative.id }}</td>
                                    <td>{{ creative.creative_source ?? '-' }}</td>
                                    <td>{{ creative.creator ?? '-' }}</td>
                                    <td style="text-align: right;">{{ creative.metrics?.amount_spent ? (creative.metrics?.amount_spent | currency) : '-' }}</td>
                                    <td style="text-align: right;">{{ creative.metrics?.purchases ? (creative.metrics?.purchases | number) : '-' }}</td>
                                    <td style="text-align: right;">{{ creative.metrics?.revenue ? (creative.metrics?.revenue | currency) : '-' }}</td>
                                    <td style="text-align: right;">{{ creative.metrics?.roas ? (creative.metrics?.roas | number:'1.2-2') : '-' }}</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>                

                
                <!-- 
                Top Creatives by ROAS View
                -->
                <div *ngIf="views.creativesTopROAS.show">
                    <div class="row align-items-center" style="margin-bottom: 10px;">
                        <div class="col">
                            <h3>{{ views.creativesTopROAS.title }}</h3>
                            <div class="small">{{ views.creativesTopROAS.description }}</div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group" style="height: 38px;">
                                <span class="input-group-text" style="font-size: 0.85em;">Min. Spend</span>                              
                                <input
                                    class="form-control"
                                    [(ngModel)]="views.creativesTopROAS.amount_spent_min"
                                    (keydown.enter)="changeFilter('creativesTopROAS', 'amount_spent_min', views.creativesTopROAS.amount_spent_min)"
                                    style="width: 80px; font-size: 0.85em;"
                                />
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group" style="height: 38px;">
                                <span class="input-group-text" style="font-size: 0.85em;">Max. Spend</span>                              
                                <input
                                    class="form-control"
                                    [(ngModel)]="views.creativesTopROAS.amount_spent_max"
                                    (keydown.enter)="changeFilter('creativesTopROAS', 'amount_spent_max', views.creativesTopROAS.amount_spent_max)"
                                    style="width: 80px; font-size: 0.85em;"
                                />
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.creativesTopROAS.dateStart"
                                    name="dp"
                                    [(ngModel)]="views.creativesTopROAS.dateStart"
                                    (ngModelChange)="changeDate('creativesTopROAS', 'start', $event)"
                                    ngbDatepicker
                                    #datePickercreativesTopROASDateStart="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickercreativesTopROASDateStart.toggle()" type="button"></button>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.creativesTopROAS.dateEnd"
                                    name="dp"
                                    [(ngModel)]="views.creativesTopROAS.dateEnd"
                                    (ngModelChange)="changeDate('creativesTopROAS', 'end', $event)"
                                    ngbDatepicker
                                    #datePickercreativesTopROASDateEnd="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickercreativesTopROASDateEnd.toggle()" type="button"></button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="views.creativesTopROAS.loadingCreativesTopROAS" style="text-align: center; margin-top: 30px;"><span class="spinner-border text-dark" role="status" aria-hidden="true" style="vertical-align: middle; margin: 10px 0;"></span></div>
                    <div class="row row-cols-auto justify-content-center">
                        <div *ngFor="let creative of views.creativesTopROAS.creatives" class="col">
                          <div class="card" style="width: 190px; margin-bottom: 20px;">
                            <img [src]="creative.image_url" style="max-width: 190px; max-height: 190px;" class="card-img-top">
                            <div class="card-body">
                              <h6 class="card-title">{{ creative.id }}</h6>
                              <div class="row align-items-center">
                                <div class="col-auto" style="font-size: 0.75em;">ROAS</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-dark">{{ creative.metrics?.roas | number:'1.2-2' }}</span></div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Ad Spend</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-secondary">{{ creative.metrics?.amount_spent | currency }}</span></div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Revenue</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-secondary">{{ creative.metrics?.revenue | currency }}</span></div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Purchases</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-secondary">{{ creative.metrics?.purchases | number }}</span></div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Source</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;">{{ creative.creative_source ?? '-' | shorten: 12 }}</div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Creator</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;">{{ creative.creator ?? '-' | shorten: 12 }}</div>
                              </div>
                              
                            </div>
                          </div>
                        </div>
                    </div>
                </div>

                
                <!-- 
                Lowest Creatives by ROAS View
                -->
                <div *ngIf="views.creativesLowestROAS.show">
                    <div class="row align-items-center" style="margin-bottom: 10px;">
                        <div class="col">
                            <h3>{{ views.creativesLowestROAS.title }}</h3>
                            <div class="small">{{ views.creativesLowestROAS.description }}</div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group" style="height: 38px;">
                                <span class="input-group-text" style="font-size: 0.85em;">Min. Spend</span>                              
                                <input
                                    class="form-control"
                                    [(ngModel)]="views.creativesLowestROAS.amount_spent_min"
                                    (keydown.enter)="changeFilter('creativesLowestROAS', 'amount_spent_min', views.creativesLowestROAS.amount_spent_min)"
                                    style="width: 80px; font-size: 0.85em;"
                                />
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group" style="height: 38px;">
                                <span class="input-group-text" style="font-size: 0.85em;">Max. Spend</span>                              
                                <input
                                    class="form-control"
                                    [(ngModel)]="views.creativesLowestROAS.amount_spent_max"
                                    (keydown.enter)="changeFilter('creativesLowestROAS', 'amount_spent_max', views.creativesLowestROAS.amount_spent_max)"
                                    style="width: 80px; font-size: 0.85em;"
                                />
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.creativesLowestROAS.dateStart"
                                    name="dp"
                                    [(ngModel)]="views.creativesLowestROAS.dateStart"
                                    (ngModelChange)="changeDate('creativesLowestROAS', 'start', $event)"
                                    ngbDatepicker
                                    #datePickercreativesLowestROASDateStart="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickercreativesLowestROASDateStart.toggle()" type="button"></button>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.creativesLowestROAS.dateEnd"
                                    name="dp"
                                    [(ngModel)]="views.creativesLowestROAS.dateEnd"
                                    (ngModelChange)="changeDate('creativesLowestROAS', 'end', $event)"
                                    ngbDatepicker
                                    #datePickercreativesLowestROASDateEnd="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickercreativesLowestROASDateEnd.toggle()" type="button"></button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="views.creativesLowestROAS.loadingCreativesLowestROAS" style="text-align: center; margin-top: 30px;"><span class="spinner-border text-dark" role="status" aria-hidden="true" style="vertical-align: middle; margin: 10px 0;"></span></div>
                    <div class="row row-cols-auto justify-content-center">
                        <div *ngFor="let creative of views.creativesLowestROAS.creatives" class="col">
                          <div class="card" style="width: 190px; margin-bottom: 20px;">
                            <img [src]="creative.image_url" style="max-width: 190px; max-height: 190px;" class="card-img-top">
                            <div class="card-body">
                              <h6 class="card-title">{{ creative.id }}</h6>
                              <div class="row align-items-center">
                                <div class="col-auto" style="font-size: 0.75em;">ROAS</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-dark">{{ creative.metrics?.roas | number:'1.2-2' }}</span></div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Ad Spend</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-secondary">{{ creative.metrics?.amount_spent | currency }}</span></div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Revenue</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-secondary">{{ creative.metrics?.revenue | currency }}</span></div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Purchases</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-secondary">{{ creative.metrics?.purchases | number }}</span></div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Source</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;">{{ creative.creative_source ?? '-' | shorten: 12 }}</div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Creator</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;">{{ creative.creator ?? '-' | shorten: 12 }}</div>
                              </div>
                              
                            </div>
                          </div>
                        </div>
                    </div>
                </div>

                
                <!-- 
                Creatives by Source View
                -->
                <div *ngIf="views.creativesSource.show">
                    <div class="row align-items-center" style="margin-bottom: 10px;">
                        <div class="col">
                            <h3>{{ views.creativesSource.title }}</h3>
                            <div class="small">{{ views.creativesSource.description }}</div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group" style="height: 38px;">
                                <span class="input-group-text" style="font-size: 0.85em;">Source</span>                              
                                <select
                                    class="form-select"
                                    style="width: 140px; font-size: 0.85em;"
                                    [(ngModel)]="views.creativesSource.source"
                                    (change)="changeFilter('creativesSource', 'creative_source', views.creativesSource.source)"
                                >
                                    <option value="">Select...</option>
                                    <option *ngFor="let source of creativeSources" [value]="source">
                                        {{ source }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.creativesSource.dateStart"
                                    name="dp"
                                    [(ngModel)]="views.creativesSource.dateStart"
                                    (ngModelChange)="changeDate('creativesSource', 'start', $event)"
                                    ngbDatepicker
                                    #datePickercreativesSourceDateStart="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickercreativesSourceDateStart.toggle()" type="button"></button>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.creativesSource.dateEnd"
                                    name="dp"
                                    [(ngModel)]="views.creativesSource.dateEnd"
                                    (ngModelChange)="changeDate('creativesSource', 'end', $event)"
                                    ngbDatepicker
                                    #datePickercreativesSourceDateEnd="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickercreativesSourceDateEnd.toggle()" type="button"></button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="views.creativesSource.loadingCreativesSource" style="text-align: center; margin-top: 30px;"><span class="spinner-border text-dark" role="status" aria-hidden="true" style="vertical-align: middle; margin: 10px 0;"></span></div>
                    <div *ngIf="!views.creativesSource.loadingCreativesSource && views.creativesSource.creatives.length === 0" style="text-align: center; margin-top: 30px; font-style: italic;">No creatives found for this source. Try expanding the date interval?</div>
                    <div class="row row-cols-auto justify-content-center">
                        <div *ngFor="let creative of views.creativesSource.creatives" class="col">
                          <div class="card" style="width: 190px; margin-bottom: 20px;">
                            <img [src]="creative.image_url" style="max-width: 190px; max-height: 190px;" class="card-img-top">
                            <div class="card-body">
                              <h6 class="card-title">{{ creative.id }}</h6>
                              <div class="row align-items-center">
                                <div class="col-auto" style="font-size: 0.75em;">ROAS</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-dark">{{ creative.metrics?.roas | number:'1.2-2' }}</span></div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Ad Spend</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-secondary">{{ creative.metrics?.amount_spent | currency }}</span></div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Revenue</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-secondary">{{ creative.metrics?.revenue | currency }}</span></div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Purchases</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-secondary">{{ creative.metrics?.purchases | number }}</span></div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Source</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;">{{ creative.creative_source ?? '-' | shorten: 12 }}</div>
                              </div>
                              <div class="row align-items-center" style="margin-top: 5px;">
                                <div class="col-auto" style="font-size: 0.75em;">Creator</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;">{{ creative.creator ?? '-' | shorten: 12 }}</div>
                              </div>
                              
                            </div>
                          </div>
                        </div>
                    </div>
                </div>

            </div>                            

        </div>    
    </div>
</div>